<template>
    <div class="dialog-screen">
        <div class="table-layout">
            <el-table class="thin" :data="pageDevcDefImpList" :height="tableHeight" ref="devcDefImpInfoTable" border style="width: 100%; font-size: 12px" @selection-change="handleSelectionChange" :row-class-name="markSelectedRowClassName">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="源件" width="60" align="center" fixed="left">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span v-else class="font-gray3">未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" width="300" align="left" fixed="left" v-show="startFlag"></el-table-column>
                <el-table-column label="资产定义编码">
                    <el-table-column prop="assetDefInnerCode" width="200" :render-header="setBathDevcDef">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.assetDefInnerCode.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.assetDefInnerCode.errorMsg">
                                <div class="inline-block">{{rows.row.assetDefInnerCode}}</div>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.assetDefId == null || rows.row.assetDefId == -1" @click="setDevcDef(rows.row)">选择</a>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.assetDefId != null && rows.row.assetDefId != -1" @click="showDevcDef(rows.row.assetDefId)">查看</a>
                            </div>
                            <div v-else>
                                <div class="inline-block">{{rows.row.assetDefInnerCode}}</div>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.assetDefId == null || rows.row.assetDefId == -1" @click="setDevcDef(rows.row)">选择</a>
                                <a class="swb-btn-link fr inline-block" v-if="rows.row.assetDefId != null && rows.row.assetDefId != -1" @click="showDevcDef(rows.row.assetDefId)">查看</a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="名称">
                    <el-table-column prop="name" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.name.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.name" :title="rows.row.validateInfo.name.errorMsg"/>
                            <input type="text" v-else style="width:180px" @change="commonChangeEvent" v-model="rows.row.name"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="定义编码">
                    <el-table-column prop="innerCode" width="180">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.innerCode.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.innerCode" :title="rows.row.validateInfo.innerCode.errorMsg"/>
                            <input type="text" v-else style="width:170px" @change="commonChangeEvent" v-model="rows.row.innerCode"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="维保分组">
                    <el-table-column prop="devcGroupFullName" label="设置" width="150" :render-header="setDevcGroup">
                        <template slot-scope="rows">
                            <div>{{rows.row.devcGroupFullName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="分类">
                    <el-table-column prop="catName" label="设置" width="150" :render-header="setCat">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.catName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.catName.errorMsg">
                                <span>{{rows.row.catName}}&nbsp;</span>
                            </div>
                            <div v-else>{{rows.row.catName}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="品牌">
                    <el-table-column prop="brandName" width="150" :render-header="setBrand">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.brandName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.brandName.errorMsg">
                                <span>{{rows.row.brandName}}</span>
                            </div>
                            <span v-else>{{rows.row.brandName}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="型号">
                    <el-table-column prop="model" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.model.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.model" :title="rows.row.validateInfo.model.errorMsg"/>
                            <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.model"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="规格">
                    <el-table-column prop="fixedSpec" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.fixedSpec.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.fixedSpec" :title="rows.row.validateInfo.fixedSpec.errorMsg"/>
                            <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.fixedSpec"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="资产描述全称">
                    <el-table-column prop="name" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.title.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.title" :title="rows.row.validateInfo.title.errorMsg"/>
                            <input type="text" v-else style="width:180px" @change="commonChangeEvent" v-model="rows.row.title"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="单位">
                    <el-table-column prop="theUnit">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.theUnit.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.theUnit" :title="rows.row.validateInfo.theUnit.errorMsg"/>
                            <input type="text" v-else style="width:90%" @change="commonChangeEvent" v-model="rows.row.theUnit"/>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10" @click="downloadDevcDefImpModel">导出全部组装件定义</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doDevcDefImpModelImport">逐条检查导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateMerchtDevcDefImpModel(true)">逐条检查</div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openPageRouteUrl, getDefaultPageSizes } from '../../../src/app.conf'
    import { openCategTreeSelectDlg, openBrandListSelectDlg, showDevcCatSelectDlg, showDevcBrandSelectDlg, showDevcGroupSelectDlg } from '../categ/selectDlg'
    import { showMerchtDevcDefSelectDlg, openDevcDefDetailDlg } from '../devcDef/showDlg'
    import { showDevcGroupCatSelectDlg } from '../categ/selectDlg'

    import asmblAccApi from '../../api/asmblAcc'

    export default {
        name: 'swb-asmbl-acc-def-imp-check',
        desc: '增加定义导入检查',
        props: ['fileObj', 'rootWidth', 'rootHeight', 'theDlg'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageDevcDefImpList: {},
                devcDefImpDto: {
                    originalFileName: null,
                    impInfoList: [],
                },
                isOk: false,
                theLoading: null,
                multipleSelection: [],
                retailerInfo: null,
                max_quantity_per_item: 500,
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0,
                updateWayFlag: false,
            }
        },
        watch: {
            rootWidth(newVal, oldVal){
                //
            },
            rootHeight(newVal, oldVal){
                this.recalcTableHeight();
            }
        },
        created: function () {
            this.recalcTableHeight();
            //
            let self = this;
            let theLoading = MsgBox.loading();
            this.devcDefImpDto.originalFileName = this.fileObj.extra.originalFileName;
            let devcDefImpInfoList = this.fileObj.extra.impInfoList || [];
            devcDefImpInfoList.forEach(function (el) {
                el.validateInfo = {
                    name: {validateOk: true},
                    devcGroupFullName: {validateOk: true},
                    catName: {validateOk: true},
                    brandName: {validateOk: true},
                    model: {validateOk: true},
                    fixedSpec: {validateOk: true},
                    title: {validateOk: true},
                    innerCode: {validateOk: true},
                    theUnit: {validateOk: true},
                    assetDefInnerCode: {validateOk: true},
                };
            });
            this.devcDefImpDto.impInfoList = devcDefImpInfoList;
            //
            this.pageSize = this.pageSizes.first();
            self.checkData();
            self.setPageDevcDefImpInfoList();
            theLoading.close();
        },
        methods: {
            recalcTableHeight(){
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            // 选中行
            markSelectedRowClassName(row){
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            //自动合并数据行
            commonChangeEvent(row, fieldName){
                //
                this.checkData();
            },
            dlgSetDevcDefImpDto: function (devcDefImpDto) {
                let self = this;
                //
                let devcDefImpInfoList = devcDefImpDto.impInfoList;
                devcDefImpInfoList.forEach(function (el) {
                    el.validateInfo = {
                        name: {validateOk: true},
                        devcGroupFullName: {validateOk: true},
                        catName: {validateOk: true},
                        brandName: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        title: {validateOk: true},
                        innerCode: {validateOk: true},
                        theUnit: {validateOk: true},
                        assetDefInnerCode: {validateOk: true},
                    };
                });
                self.devcDefImpDto = devcDefImpDto;
                setTimeout(
                    function () {
                        self.checkData();
                    }, 1000
                );

            },
            checkData () {
                let self = this;
                let rows = this.devcDefImpDto.impInfoList.clone();
                let itemLength = rows.length;
                let byItemFlag = itemLength > 500;
                for(let i = 0; i < rows.length; i++) {
                    let devcDefImpDto = rows[i];
                    devcDefImpDto.validateInfo = {
                        name: {validateOk: true},
                        devcGroupFullName: {validateOk: true},
                        catName: {validateOk: true},
                        brandName: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        title: {validateOk: true},
                        innerCode: {validateOk: true},
                        theUnit: {validateOk: true},
                        assetDefInnerCode: {validateOk: true},
                    };
                    // 检查 [定义名称]
                    if(!Utils.isNoB(devcDefImpDto.name)) {
                        devcDefImpDto.name = this.replaceSL(devcDefImpDto.name, ' ');
                    }
                    if(Utils.isNoB(devcDefImpDto.name)) {
                        devcDefImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[名称]单元不可为空"
                        };
                    } else if(devcDefImpDto.name.length > 30) {
                        devcDefImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[名称]单元长度最大30，当前[" + devcDefImpDto.name.length + "]"
                        };
                    }
                    // 检查 [维保分组]
                    if(Utils.isNoB(devcDefImpDto.devcGroupFullName) && !byItemFlag) {
                        devcDefImpDto.validateInfo.devcGroupFullName = {
                            validateOk: false,
                            errorMsg: "请选择维保分组"
                        };
                    }
                    // 检查 [品牌]
                    if(devcDefImpDto.innerCode == null && !byItemFlag) {
                        devcDefImpDto.validateInfo.innerCode = {
                            validateOk: false,
                            errorMsg: "定义编码不可为空"
                        };
                    }
                    // 检查 [型号]
                    if(!Utils.isNoB(devcDefImpDto.model)) {
                        devcDefImpDto.model = this.replaceSL(devcDefImpDto.model, ' ');
                    }
                    if(Utils.isNoB(devcDefImpDto.model)) {
                        devcDefImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[型号]单元不能为空"
                        };
                    } else if(devcDefImpDto.model.length > 30) {
                        devcDefImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[型号]单元长度最大30，当前[" + devcDefImpDto.model.length + "]"
                        };
                    }
                    // 检查 [规格]
                    if(!Utils.isNoB(devcDefImpDto.fixedSpec)) {
                        devcDefImpDto.fixedSpec = this.replaceSL(devcDefImpDto.fixedSpec, ' ');
                    }
                    if(Utils.isNoB(devcDefImpDto.fixedSpec)) {
                        devcDefImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格]单元不能为空"
                        };
                    } else if(devcDefImpDto.fixedSpec.length > 45) {
                        devcDefImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格]单元长度最大45，当前[" + devcDefImpDto.fixedSpec.length + "]"
                        };
                    }
                    // 检查 [资产描述全称]
                    if(!Utils.isNoB(devcDefImpDto.title)) {
                        devcDefImpDto.title = this.replaceSL(devcDefImpDto.title, ' ');
                    }
                    if(Utils.isNoB(devcDefImpDto.title)) {
                        devcDefImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[资产描述全称]单元不可为空"
                        };
                    } else if(devcDefImpDto.title.length > 60) {
                        devcDefImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[资产描述全称]单元长度最大60，当前[" + devcDefImpDto.title.length + "]"
                        };
                    }
                    if(devcDefImpDto.id != null) {
                        devcDefImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                        devcDefImpDto.validateInfo.catName = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                        devcDefImpDto.validateInfo.brandName = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                        devcDefImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                        devcDefImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                        devcDefImpDto.validateInfo.theUnit = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                        devcDefImpDto.validateInfo.innerCode = {
                            validateOk: false,
                            errorMsg: "[分类+品牌+名称+型号+规格+单位] 或 [定义编码]系统中已存在"
                        };
                    }
                    // 检查 [单位]
                    if(!Utils.isNoB(devcDefImpDto.theUnit)) {
                        devcDefImpDto.theUnit = this.replaceSL(devcDefImpDto.theUnit, '');
                        if(devcDefImpDto.theUnit.length > 5) {
                            devcDefImpDto.validateInfo.theUnit = {
                                validateOk: false,
                                errorMsg: "[单位]单元长度最大5，当前[" + devcDefImpDto.theUnit.length + "]"
                            };
                        }
                    }
                    if(!Utils.isNoB(devcDefImpDto.assetDefInnerCode) && devcDefImpDto.assetDefId == null) {
                        devcDefImpDto.validateInfo.assetDefInnerCode = {
                            validateOk: false,
                            errorMsg: "[资产定义编码]单元无效"
                        };
                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
                //
                this.devcDefImpDto.impInfoList = rows;
                this.setPageDevcDefImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.devcDefImpDto.impInfoList.forEach(function (row) {
                        if(oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.devcDefImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageDevcDefImpInfoList: function () {
                let totalRows = this.devcDefImpDto.impInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                //
                this.pageDevcDefImpList = totalRows.slice(start, end);
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageDevcDefImpInfoList();
            },
            downloadDevcDefImpModel: function () {
                asmblAccApi.asmblAccDefImpModelForExport(this.devcDefImpDto, function (result) {
                    if(result.type == 'info') {
                        Utils.downloadFile(getAppUrl(result.data));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            setDevcGroup (h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let params = {
                                    filter: {
                                        level: 2
                                    },
                                    checkBox: false
                                };
                                showDevcGroupSelectDlg(params, function (devcGroup, theDlg) {
                                    theDlg.close();
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        let model = self.devcDefImpDto.impInfoList.find(function (row) {
                                            return row.rowNo == tmpRow.rowNo;
                                        });
                                        //
                                        model.devcGroupId = devcGroup.id;
                                        model.devcGroupFullName = devcGroup.fullName;
                                        model.catId = null;
                                        model.catName = null;
                                    }
                                    self.checkData();
                                    return true;
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            // 设置分类
            setCat (h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                let multipleSelection = self.multipleSelection || [];
                                if(multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let devcGroupId = null;
                                for(let i = 0; i < multipleSelection.length; i++) {
                                    let multipleSelect = multipleSelection[i];
                                    if(Utils.isNoB(multipleSelect.devcGroupId)) {
                                        self.$message.warning("请先确认维保分组");
                                        return;
                                    }
                                    if(Utils.isNoB(devcGroupId)) {
                                        devcGroupId = multipleSelect.devcGroupId;
                                    } else if(multipleSelect.devcGroupId != devcGroupId) {
                                        self.$message.warning("请选择相同维保分组的数据");
                                        return;
                                    }
                                }
                                let params = {
                                    filter: {
                                        groupId: devcGroupId,
                                        level: 2
                                    },
                                    checkBox: false,
                                };
                                showDevcGroupCatSelectDlg(params, function (resultData, theDlg) {
                                    theDlg.close();
                                    let categ = Utils.merge({}, resultData);
                                    //
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        let model = self.devcDefImpDto.impInfoList.find(function (row) {
                                            return row.rowNo == tmpRow.rowNo;
                                        });
                                        //
                                        model.catId = categ.catId;
                                        model.catName = categ.catName;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            // 设置品牌
            setBrand(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行！");
                                    return;
                                }
                                let catIds = [];
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    let obj = self.multipleSelection[i];
                                    let catId = obj.catId;
                                    if(Utils.isNoB(catId)) {
                                        self.$message.warning("请先设置分类！");
                                        return;
                                    }
                                    if(!catIds.contains(catId)) {
                                        catIds.push(catId);
                                    }
                                }
                                if(catIds.length > 1) {
                                    self.$message.warning("勾选的行的分类必须一致！");
                                    return;
                                }
                                let params = {
                                    catId: catIds[0],
                                    showAll: false
                                };
                                openBrandListSelectDlg(false, params, function (brand) {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].brandId = brand.id;
                                        self.multipleSelection[i].brandName = brand.dispName;
                                    }
                                    self.checkData();
                                    return true;
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            // 选择行
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 逐条检查
            validateMerchtDevcDefImpModel: function (isFirst) {
                this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
                this.startFlag = true;
                let self = this;
                let devcDefImpDto = this.devcDefImpDto;
                //
                let srcDevcDefImpInfoList = devcDefImpDto.impInfoList || [];
                let srcListLength = srcDevcDefImpInfoList.length;
                //
                let checkNextIndex = this.checkNextIndex;
                let srcImpInfo = srcDevcDefImpInfoList[checkNextIndex];
                let postData = Utils.merge({}, devcDefImpDto);
                postData.impInfoList = [srcImpInfo];
                postData.devcFlag = true;
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                asmblAccApi.validateAsmblAccDefImpModel(postData, function (result) {
                    theLoading.hide();
                    let callItem = result.data.impInfoList[0];
                    if(result.type == 'info') {
                        callItem.failed = false;
                        callItem.failDesc = null;
                    } else {
                        callItem.failed = true;
                        callItem.failDesc = result.message;
                    }
                    srcDevcDefImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                    devcDefImpDto.srcDevcDefImpInfoList = srcDevcDefImpInfoList;
                    self.devcDefImpDto = Utils.merge({}, devcDefImpDto);
                    self.checkData();
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (checkNextIndex + 1) / pageSize;
                    let pageNumber2 = (checkNextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    self.handlePageChange(pageNumber);
                    //
                    if(checkNextIndex < srcListLength - 1) {
                        self.checkNextIndex += 1;
                        self.validateMerchtDevcDefImpModel(false);
                    } else {
                        self.handlePageChange(1);
                    }
                });
            },
            // 逐条检查导入
            doDevcDefImpModelImport(){
                let self = this;
                let devcDefImpDto = this.devcDefImpDto;
                // 判断全部的状态是否是ok
                let srcDeviceImpInfoList = devcDefImpDto.impInfoList || [];
                let srcListLength = srcDeviceImpInfoList.length;
                if(srcListLength > 500) {
                    //弹出确认框
                    this.$confirm('数据较多,将会执行一段时间,请勿关闭此页面或关闭浏览器,确定导入吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.doDevcDefImpModelImportStart();
                    }).catch(function () {

                    });
                } else {
                    self.doDevcDefImpModelImportStart();
                }
            },
            // 开始导入
            doDevcDefImpModelImportStart(){
                this.startFlag = true;
                let srcDeviceImpDto = this.devcDefImpDto;
                //
                let impDto = {};
                impDto.merchantId = srcDeviceImpDto.merchantId;
                impDto.originalFileName = srcDeviceImpDto.originalFileName;
                impDto.dumyBrandNames = srcDeviceImpDto.dumyBrandNames;
                impDto.virtualType = srcDeviceImpDto.virtualType;
                impDto.updateWayFlag = Utils.isTrue(this.updateWayFlag);
                //
                this.startDone(impDto);
            },
            startDone(impDto){
                let self = this;
                let nextIndex = this.nextIndex;
                let srcDeviceImpDto = this.devcDefImpDto;
                let srcDeviceImpInfoList = srcDeviceImpDto.impInfoList || [];
                let srcListLength = srcDeviceImpInfoList.length;
                let srcImpInfo = srcDeviceImpInfoList[nextIndex];
                impDto.impInfoList = [srcImpInfo];
                impDto.devcFlag = true;
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                asmblAccApi.doAsmblAccDefImpModelImport(impDto, function (result) {
                    theLoading.close();
                    let resultDto = result.data;
                    if(result.type == 'info') {
                        srcImpInfo.failed = false;
                        srcImpInfo.failDesc = null;
                    } else {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = result.message;
                    }
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (nextIndex + 1) / pageSize;
                    let pageNumber2 = (nextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    if(!Utils.isNoB(resultDto) && !Utils.isNoB(resultDto.errMsg)) {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = resultDto.errMsg;
                        self.handlePageChange(pageNumber);
                        MsgBox.warning("源件行号：" + srcImpInfo.rowNo + "】:" + resultDto.errMsg);
                    } else {
                        self.handlePageChange(pageNumber);
                        //
                        if(nextIndex < (srcListLength - 1)) {
                            self.nextIndex = nextIndex + 1;
                            self.startDone(impDto);
                        } else {
                            self.$emit('other-close');
                        }
                    }
                });
            },
            replaceSL(str, char){
                if(!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            },
            setDevcCat(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                showDevcCatSelectDlg({
                                    filter: {
                                        relSysFlag: true,
                                        disabled: false,
                                        level: 3
                                    }
                                }, function (devcCat, theDlg) {
                                    theDlg.close();
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        let row = self.multipleSelection[i];
                                        row.catId = devcCat.goodsCatId;
                                        row.catName = devcCat.goodsCatName;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            setDevcBrand(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                //
                                showDevcBrandSelectDlg({
                                    filter: {
                                        relSysFlag: true,
                                        disabled: false
                                    }
                                }, function (devcBrand, theDlg) {
                                    theDlg.close();
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].brandId = devcBrand.sysBrandId;
                                        self.multipleSelection[i].brandName = devcBrand.sysBrandName;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            setBathDevcDef(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let params = {};
                                params.assetType = 0;
                                showMerchtDevcDefSelectDlg(params, function (devcDef, dlg) {
                                    dlg.close();
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].assetDefId = devcDef.id;
                                        self.multipleSelection[i].assetDefInnerCode = devcDef.innerCode;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '选择'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的资产定义编码吗?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].assetDefId = null;
                                        self.multipleSelection[i].assetDefInnerCode = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setDevcDef(row) {
                let self = this;
                let modelSpec = row.model + '' + row.fixedSpec;
                showMerchtDevcDefSelectDlg({
                    catId: row.catId,
                    brandId: row.brandId,
                    modelSpec: modelSpec,
                    assetType: 0,
                }, function (devcDef, dlg) {
                    dlg.close();
                    row.assetDefId = devcDef.id;
                    row.assetDefInnerCode = devcDef.innerCode;
                    self.checkData();
                });
            },
            showDevcDef(id){
                openDevcDefDetailDlg(id);
            },
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/asmblAcc/AsmblAccDefImpCheck.vue